// Components
import Store from './details';

// Redux
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { Creators as StoreActions } from 'store/ducks/store';
import { Creators as ModalActions } from 'store/ducks/modal';

// Helpers
import { IReduxStore } from 'utils/interfaces/IReduxStore';

const mapStateToProps = ({ store }: IReduxStore) => ({ store });

const mapDispatchToProps = (dispatch: Dispatch) => ({
    storeActions: bindActionCreators(StoreActions, dispatch) as any,
    modalActions: bindActionCreators(ModalActions, dispatch) as any
});

export default connect(mapStateToProps, mapDispatchToProps)(Store);
